import { render, staticRenderFns } from "./CampaignInformationVSelectPhoneNumber.vue?vue&type=template&id=24b624b8&scoped=true&"
import script from "./CampaignInformationVSelectPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./CampaignInformationVSelectPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b624b8",
  null
  
)

export default component.exports